const boxShadows = {
  exmple: "0px 1px 4px rgba(69, 37, 28, 0.15)",
  cardShadow: "0px 4px 10px 0px #0000001a",
}

export default boxShadows
